import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import { StatefulTooltip } from 'baseui/tooltip'

import { StyledSidebarDivButton, tooltipOverrides } from '../styled-components'
import IconCarbonUnknown from '@/shared/icons/IconCarbonUnknown'

const SidebarRouterButton = ({ icon, isSelected, text }) => {
  const [, theme] = useStyletron()
  const iconProps = {
    size: 24,
    color: isSelected ? theme.colors.white : theme.colors.primary,
    title: '',
  }
  return (
    <StatefulTooltip content={text} popoverMargin={8} overrides={tooltipOverrides()}>
      <StyledSidebarDivButton $isSelected={isSelected ?? false}>
        {icon ? icon(iconProps) : <IconCarbonUnknown {...iconProps} />}
      </StyledSidebarDivButton>
    </StatefulTooltip>
  )
}

SidebarRouterButton.propTypes = {
  classes: PropTypes.string,
  clickHandler: PropTypes.func,
  icon: PropTypes.func,
  isSelected: PropTypes.bool,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
}

export default SidebarRouterButton
